// ── Búsqueda por palabras, del lado del navegador ────────────────────────────
// Gemelo de packages/server/src/db/searchTerms.ts. Algunos módulos filtran su
// lista en el navegador en vez de pedirle al servidor — Proyectos, Formularios,
// Tareas — y ahí el arreglo del servidor no llega.
//
// Mismo criterio: CADA palabra tiene que aparecer en ALGUNO de los campos.
// "Villa Sion contacto" encuentra el formulario cuyo nombre es
// "Contacto — Villa Sion" aunque las palabras estén en otro orden.
//
// Los dos archivos tienen que moverse juntos: si mañana el criterio cambia acá
// y no allá, el mismo texto tipeado devuelve cosas distintas según el módulo,
// que es peor que si los dos estuvieran igual de mal.

const MAX_TOKENS = 8;

/** Lo entrecomillado cuenta como una sola palabra: `"buenos aires"`. */
export function splitSearchTokens(term: string): string[] {
  const tokens: string[] = [];
  const re = /"([^"]+)"|(\S+)/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(term)) !== null) {
    const tok = (m[1] ?? m[2] ?? '').trim();
    if (tok) tokens.push(tok);
    if (tokens.length >= MAX_TOKENS) break;
  }
  return tokens;
}

/**
 * ¿Los campos de este ítem satisfacen lo tipeado?
 *
 * Un término vacío devuelve `true` — sin búsqueda no se filtra nada, igual que
 * antes. Los campos `null`/`undefined` se ignoran en vez de romper.
 */
export function matchesSearch(term: string, fields: Array<string | null | undefined>): boolean {
  const tokens = splitSearchTokens(term ?? '');
  if (tokens.length === 0) return true;

  const texto = fields.filter(Boolean).map(f => f!.toLowerCase());
  return tokens.every(tok => {
    const t = tok.toLowerCase();
    return texto.some(f => f.includes(t));
  });
}
